import { render } from "./CompanyLogo.vue?vue&type=template&id=f796eb2a&scoped=true"
import script from "./CompanyLogo.vue?vue&type=script&lang=js"
export * from "./CompanyLogo.vue?vue&type=script&lang=js"

import "./CompanyLogo.vue?vue&type=style&index=0&id=f796eb2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f796eb2a"]])

export default __exports__